import { Input } from "@/components/ui/input";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { ChevronUpIcon, PlusCircleIcon, StopIcon } from "@/components/fun-ui/icons";
import { Popover, PopoverContent, PopoverTrigger } from "../fun-ui/Popover";
import { Button } from "@/components/fun-ui/Button";

interface AuthorsSelectorProps {
  disabled: boolean;
  value: string;
  onValueChange: (value: string) => void;
  maxLength?: number;
  maxCounts?: number;
  placeholder?: string;
}

export const AuthorsSelector = ({
  disabled = false,
  value = '',
  onValueChange,
  maxLength = 100,
  maxCounts = 20,
  placeholder = '',
}: AuthorsSelectorProps) => {
  const [authors, setAuthors] = useState<string[]>([]);
  const [newAddAuthor, setNewAddAuthor] = useState<string>('');
  const [isOpen, setIsOpen] = useState(false);
  // const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    const authors = value.split(/,|，/)
      .map((item) => item.trim())
      .filter((item) => !!item)
      .slice(0, maxCounts);
    setAuthors(authors);
  }, [value, maxCounts]);

  // useEffect(() => {
  //   setNewAddAuthor('');
  // }, [isDeleteOpen]);

  useEffect(() => {
    if (!isOpen) {
      setNewAddAuthor('');
    }
  }, [isOpen]);

  return (
    <div className="flex flex-col">
      <Popover
        open={isOpen}
        onOpenChange={(open) => {
          setIsOpen(open);
        }}
      >
        <PopoverTrigger asChild>
          {
            authors.length >= maxCounts ? (
              null
            ) : (
              <div
                className="flex items-center gap-1 text-primary cursor-pointer group self-end -mt-8"
              >
                <PlusCircleIcon size="16" />
                <span className="text-muted-foreground text-sm">添加作者</span>
              </div>
            )
          }
        </PopoverTrigger>
        <PopoverContent className="flex flex-row items-center w-80 p-0 justify-between" align="end">
          <Input
            disabled={disabled}
            className="flex-1 border-none pr-0"
            value={newAddAuthor}
            onChange={(e) => {
              setNewAddAuthor(e.currentTarget.value);
            }}
            maxLength={maxLength}
          />
          <div className="flex flex-row text-nowrap items-center">
            <Button
              variant="link"
              className="p-0 px-3 font-normal text-muted-foreground hover:no-underline"
              onClick={() => {
                setIsOpen(false);
              }}
            >取消</Button>
            <div className="bg-border h-3 w-[1px]" />
            <Button
              variant="link"
              className="p-0 px-3 font-normal hover:no-underline"
              disabled={!newAddAuthor.trim() || authors.includes(newAddAuthor) || disabled}
              onClick={() => {
                if (!newAddAuthor.trim() || authors.includes(newAddAuthor)) {

                } else {
                  onValueChange([...authors, newAddAuthor].join(','));
                  setIsOpen(false);
                  setShowMore(true);
                }
              }}
            >确认</Button>
          </div>
        </PopoverContent>
      </Popover>
      <div className="flex flex-wrap gap-y-2 mt-3">
        {!authors.length ? (
          <div
            className="truncate text-annotation-foreground text-sm"
          >
            {placeholder}
          </div>
        ) : (
          authors.slice(0, showMore ? authors.length : 8).map((author, index) => (
            <div
              key={author}
              className={cn(
                "flex justify-between w-1/2 text-sm font-normal",
                !!(index % 2) ? "pl-10" : "pr-10"
              )}
            >
              <div
                className="truncate text-muted-foreground"
              >
                {author}
              </div>
              <Button
                variant="link"
                disabled={disabled}
                className="text-annotation-foreground cursor-pointer hover:text-muted-foreground p-0 h-auto"
                onClick={() => {
                  const newAuthors = authors.filter((item) => item !== author);
                  onValueChange(newAuthors.length ? newAuthors.join(',') : '');
                }}
              >
                <StopIcon size="16" />
              </Button>
              {/* <Popover
              open={isDeleteOpen}
              onOpenChange={(open) => {
                setIsDeleteOpen(open);
              }}
            >
              <PopoverTrigger asChild>
                <div
                  className="text-annotation-foreground cursor-pointer hover:text-muted-foreground"
                >
                  <StopIcon size="16" />
                </div>
              </PopoverTrigger>
              <PopoverContent>
                <div className="flex flex-col">
                  <p className="text-sm text-muted-foreground">
                    <span className="font-bold block">删除文献作者</span>
                    确认删除文献作者<span className="text-destructive">{author}</span>吗？
                  </p>
                  <Button
                    size="sm"
                    variant="destructive"
                    className="self-end"
                    onClick={() => {
                      setIsDeleteOpen(false);
                    }}
                  >删除</Button>
                </div>
              </PopoverContent>
            </Popover> */}
            </div>
          ))
        )}
      </div>
      {
        authors.length > 8 ? (
          <Button
            variant="link"
            className="text-muted-foreground no-underline hover:no-underline hover:text-primary px-0 text-sm self-end"
            onClick={() => { setShowMore(!showMore) }}
          >
            <span>{showMore ? '收起作者' : '展示更多作者'}</span>
            <ChevronUpIcon
              size={16}
              className={
                cn(
                  "transition duration-200 w-4 h-4 -rotate-180",
                  showMore && "rotate-0",
                )
              }
            />
          </Button>
        ) : null
      }
    </div >
  )
}